
import { defineComponent } from "vue";
import { useAPI } from "../api";

export default defineComponent({
    name: "IsAuthenticated",
    setup() {
        const { isAuthenticated } = useAPI();
        return { isAuthenticated };
    },
});
